import { Response } from "../types";

export enum ShopStatus {
  active = "active",
  inactive = "inactive",
  repair = "repair",
  closed = "closed",
}

export enum ShopSections {
  WOMAN = "WOMAN",
  MAN = "MAN",
  KIDS = "KIDS",
}

export enum ShopClass {
  A = "A",
  B = "B",
  C = "C",
  D = "D",
  E = "E",
}

export enum UserPermissions {
  login = "login",
  mobile = "mobile",
}

export enum UserRole {
  guest = "guest",
  authenGuest = "authen_guest",
  shopEmployee = "shop_employee",
  shopConsultant = "shop_consultant",
  shopDirector = "shop_director",
  operationsDirector = "operations_director",
  superuser = "superuser",
}

export type CurrentUser = {
  user_id: string | null;
  role: UserRole;
  shop_id: string | null;
  nick: string | null;
  first_name: string | null;
  last_name: string | null;
  display_name: string | null;
  email: string | null;
  phone: string | null;
};

export type AuthorizeResponse = Response & {
  token: string;
};

export type AuthorizeRequest = {
  qr_code: string;
  device: string;
};

export enum WTFIRInputType {
  barcode = "barcode",
  rfid = "rfid",
}

export enum WTFIRTypeData {
  cis = "cis",
  epc = "epc",
  epcClear = "epc-clear",
  barcode = "barcode",
  epcNotItem = "epc-notitem",
  qr = "qr",
  epcAlarm = "epc-alarm",
  epcAlarmClear = "epc-alarm-clear",
  unknown = "unknown",
  action = "action",
}

export type WTFIRRequest = {
  data: string;
  input_type: WTFIRInputType;
};

export type WTFIRResponse = Response & {
  type_data: WTFIRTypeData;
  gtin: string;
  normalized_data: string;
  items?: string[];
  action?: {
    action: string;
    epc: string;
  } | null;
};

// TODO: тут надо перенести в папку mobile_item
// (там уже есть тип Item, но этот ещё используется в проекте)
export type Product = {
  item_id: string;
  external_id?: string;
  barcode: string[];
  title: string;
  long_title: string;
  image_url: string;
  article: string;
  status: string;
  updated: string;
  parent_guid?: string;
  color?: string;
  size?: string;
  vat?: string;
  marking?: string;
  storage_unit?: string;
  section?: string;
  gender?: string;
  age?: string;
  price?: number;
  price_markdown?: number;
  is_marked: boolean;
  is_virtual: boolean;
  seria_guid: string;
  is_blocked?: boolean;
  link_created?: string;
};

export type User = {
  role: string;
  display_name: string;
  email: string;
  first_name: string;
  last_name: string;
  nick: string;
  user_id: string;
  shop_id: string;
};

export type Permission = {
  name: string;
  value: boolean;
};

export type Profile = {
  now: string;
  current_user: User;
  permissions: Permission[];
  constants: {
    backend_version: string;
    rfid: {
      power_write: number;
      power_once_read: number;
      power_multi_read: number;
      power_alarm_read: number;
      power_locator: number;
    };
  };
};

export type ProfileOptionsResponse = Response & Profile;

export type CheckCisEpcRequest = {
  cis: string;
};

export type CheckCisEpcResponse = Response & {};

export type ItemListByZoneRequest = {
  zone_id: string;
  cursor?: string;
};

export type ItemListByZoneResponse = Response & {
  items: Product[];
  cursor: string;
};

export type ItemUnsetZoneRequest = {
  item_id: string;
  zone_ids?: string[];
};

export type ItemUnsetZoneResponse = Response & {};
export type Shop = {
  shop_id: string;
  title: string;
  address: string;
  status: ShopStatus;
  sections: ShopSections[];
  shop_class: ShopClass;
  store_types: {
    shoes: boolean;
    underwear: boolean;
    accessories: boolean;
    clothing: boolean;
  };
  config: {
    options: {
      orders: string[];
      rfid_alarm: boolean;
      manage_users: boolean;
      dc_rfid_alarm: boolean;
    };
  };
};

export type ShopLoadRequest = {
  shop_id: string;
};

export type ShopLoadResponse = Response & {
  shop: Shop;
};

export type WTFIRRequest_V2 = {
  data: string[];
  input_type: WTFIRInputType;
};

export type WTFIRResponse_V2 = Response & {
  result: {
    type_data: string;
    gtin: string;
    data: string;
    normalized_data: string;
    item: string[] | null;
  }[];
};

export type GetActionRequest = {
  action: string;
  data: Record<string, unknown>;
};

export type GetActionResponse = Response & {
  action: string;
};

export type PairEPCRequest = {
  barcode: string;
};

export type PairEPCResponse = Response & {
  epc: string;
};

export type ItemListRequest = {
  article: string;
};

export type ItemListResponse = Response & {
  items: Product[];
};

export type ItemSetBlockRequest = {
  item_id: string;
  blocked: boolean;
};

export type ItemSetBlockResponse = Response & {};

export type CheckSakesRequest = {
  cis?: string;
  epc?: string;
};

export type CheckSakesResponse = Response & {
  sales: boolean;
  status: string;
  date_sales: string;
};

export type ListByParentRequest = {
  parent_guid: string;
  cursor?: string;
};

export type ListByParentResponse = Response & {
  items: Product[];
  cursor?: string;
};

export type ListBySeriaRequest = {
  seria_guid: string;
  cursor?: string;
};

export type ListBySeriaResponse = Response & {
  items: Product[];
  cursor?: string;
};

export type LoadByExternalRequest = {
  guid: string[];
};

export type LoadByExternalResponse = Response & {
  items: Product[];
};

// -------------------------- Типы для работы с исполнителями --------------------------
export type LoadExecutorsRequest = {
  user_id: string[];
};

export type Executor = {
  user_id: string;
  display_name: string;
  status: string;
};

export type LoadExecutorsResponse = Response & {
  executors: Executor[];
};
// -------------------------- Конец типов для работы с исполнителями --------------------------
